<template lang="pug">
.fields
    EditArea.edit-area
        template(#content)
            .fields-container
                .detected-fields
                    .ftitle {{ $t(`${baseTranslationPath}.detected_fields`) }} ({{ fields.length }})
                    .fields(v-for="field in fields" :key="field.id")
                        .fcontent(@click="selectField(field)" :class="{ 'active-field': field === selectedField }")
                            .field-number {{ fields.indexOf(field) + 1 }}
                            font-awesome-icon(:icon="getFieldIconType(field).icon" class="field-icon")
                            .field-name
                                .label {{ field.label }}
                                .name-type {{ getFieldIconType(field).type }}
                .divider
                .field-configuration
                    .conf-title {{ $t(`${baseTranslationPath}.field_configuration`) }}
                    .conf-content(v-if="selectedField")
                        .conf-selected-title {{ $t(`${baseTranslationPath}.selected_field`) }}
                        .conf-header
                            .number {{ fields.indexOf(selectedField) + 1 }}
                            .inner-header
                                .inner-label {{ selectedField.label }}
                                .detected-as {{ $t(`${baseTranslationPath}.detected_as`) }} {{ getFieldIconType(selectedField).type }}

</template>
<script>
import EditArea from '@/components/EditArea.vue';
import { fieldIconTypes } from './fieldUtil';
import get from 'lodash/get';

export default {
  name: 'Fields',
  components: {
    EditArea,
  },
  props: {
    formDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      baseTranslationPath: 'iq_tools_tab.forms_tab.manage',
      selectedField: null,
    };
  },
  watch: {
    fields(newFields) {
      if (!newFields.includes(this.selectedField)) {
        this.selectedField = newFields.length > 0 ? newFields[0] : null;
      }
    },
  },
  computed: {
    fields() {
      return get(this.formDetails, 'fields', []);
    },
  },
  methods: {
    getFieldIconType(field) {
      const fieldType = get(field, 'field_type');
      return fieldIconTypes(fieldType);
    },
    selectField(field) {
      this.selectedField = field;
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'src/styles/aiq-variables.scss';

.fields-container {
    display: flex;
    width: 100%;
    margin: 10px;
    min-height: 100%;
    align-items: flex-start;
}

.inner-label {
    margin-left: 20px;
}

.inner-header {
    margin-top: 10px;
}
.conf-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    border-bottom: 1px solid $aiq-icon-primary;
    .number {
        width: 20px;
        height: 20px;
        border-radius: 10%;
        background-color: $aiq-color-black;
        color: $aiq-color-white;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        margin-bottom: 14px;
    }
}
.name-type {
    font-size: 12px;
    color: $aiq-input-border-hover;
}

.detected-as {
    font-size: 12px;
    color: $aiq-input-border-hover;
    margin-bottom: 10px;
}

.ftitle {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
}

.conf-selected-title {
    font-size: 15px;
    font-weight: bold;
}

.conf-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    border-bottom: 1px solid $aiq-icon-primary;
    margin-left: -10px;
    padding-left: 10px;
    padding-bottom: 10px;
}

.detected-fields {
    width: 50%;
    margin-right: 10px;
}

.divider {
    width: 1px;
    background-color: $aiq-icon-primary;
    align-self: stretch;
    flex-shrink: 0;
}
.field-configuration {
    width: 50%;
    margin: 10px 0;
    padding-left: 10px;
    position: sticky;
    top: 0;
    align-self: flex-start;
}
.edit-area {
  margin-top:20px;
  background-color: $aiq-bgc-list-item;
}

.field-icon {
    margin-left: 10px;
    font-size: 20px;
    color: $aiq-input-border-hover;
}

.field-name {
    margin-left: 10px;
    font-size: 14px;
}

.active-field {
    background-color: $aiq-bgc-list-item-hover;
    border: 1px solid $aiq-bgc-list-item-hover;
}
.fcontent {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 10px;
    border: 1px solid $aiq-icon-primary;
    border-radius: 5px;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover {
        background-color: $aiq-bgc-list-item-hover;
        border: 1px solid $aiq-bgc-list-item-hover;
    }
}
</style>